import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import useSeo from "@/hooks/useSeo";

export default function NotFound() {
  useSeo({ title: "Page not found — WebJesters", noindex: true });
  return (
    <main
      id="main-content"
      data-testid="not-found-page"
      className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center px-5"
    >
      <div className="max-w-md text-center">
        <div className="text-[11px] tracking-[0.22em] uppercase text-zinc-400">404</div>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl tracking-tight">
          That page isn&apos;t here.
        </h1>
        <p className="mt-4 text-zinc-400 text-[15px] leading-relaxed">
          The link may be old or mistyped. Everything you need is on the home page.
        </p>
        <Link
          to="/"
          data-testid="not-found-home"
          className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-black text-[13.5px] font-medium hover:bg-zinc-200 transition-colors"
        >
          Back to WebJesters
          <ArrowUpRight size={14} weight="bold" />
        </Link>
      </div>
    </main>
  );
}
